import React, { useState, useEffect } from "react";
import { FaSms, FaPhoneAlt, FaCommentAlt, FaWhatsapp, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import Axios from '../../../axios/Axios';
import { HOST_URL } from '../api/Api';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../DashboardLeftMenu';
import styles from "./ViewAllNotifications.module.css";
import { handleUserLog } from "../../Utils/Utils";

const channelIcons = {
  sms: <FaSms className={`${styles.notifIcon} ${styles.sms}`} />,
  voice: <FaPhoneAlt className={`${styles.notifIcon} ${styles.voice}`} />,
  rcs: <FaCommentAlt className={`${styles.notifIcon} ${styles.rcs}`} />,
  whatsapp: <FaWhatsapp className={`${styles.notifIcon} ${styles.whatsapp}`} />,
  default: <FaCommentAlt className={styles.notifIcon} />
};

const formatRemarkValue = (value) => {
  if (value === null || value === undefined || value === "") return "null";

  if (Array.isArray(value)) {
    if (value.length === 0 || value.some((item) => typeof item === "object" && item !== null)) {
      return "null";
    }
    return value.map((item) => String(item)).join(", ");
  }

  if (typeof value === "object") {
    return "null";
  }

  return String(value);
};

const ViewAllNotifications = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage.user.userId;
  const userToken = lStorage.token;

  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await Axios.post(`${HOST_URL}/notification.php`, {
        user_id: userId,
        method: "retrieve",
        token: userToken,
      });

      if (response.data.success) {
        const formatted = response.data.data.map((n) => {
          let remarkData;
          try {
            remarkData = JSON.parse(n.remark);
          } catch {
            remarkData = {};
          }

          return {
            id: n.id,
            title: n.notify_type.replace(/_/g, " "),
            message: remarkData.message_template_name
              ? `Template: ${remarkData.message_template_name}, Score: ${remarkData.new_quality_score || ""}`
              : n.notify_type,
            time: n.created,
            unread: n.read_status === 0,
            channel: n.channel || "default",
            remark: remarkData
          };
        });

        setNotifications(formatted);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({ ...n, unread: false })));
  };

  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <div className="row mb-2 mb-xl-3">
              <nav className="text-center" aria-label="breadcrumb">
                <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                  <Link to="view-all-notifications" onClick={() => handleUserLog("", "notifications_tab", "view_all_notifications", "User Click on Notifications tab", "view_all_notifications", "", "")}><li className="breadcrumb-item ml-4 active">Notifications</li></Link>
                  <Link to="notification" onClick={() => handleUserLog("", "notification_setup_tab", "view_all_notifications", "User Click on Notification Setup tab", "view_all_notifications", "", "")}><li className="breadcrumb-item">Notification Setup</li></Link>
                </ol>
              </nav>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    {/* Header with title and button */}
                    <div className={styles.headerBar}>
                      <h3>All Notifications</h3>
                      {/* <button onClick={markAllAsRead} className="btn btn-sm btn-primary">
                        Mark all as read
                      </button> */}
                    </div>

                    <div className={styles.notificationListContainer}>
                      {notifications.length === 0 && <p className="ml-2">No notifications found</p>}

                      {notifications.map((n) => (
                        <div
                          key={n.id}
                          className={`${styles.notifItem} ${n.unread ? styles.unread : ""}`}
                          onClick={() => {
                            handleUserLog("", "view_notification_button", "view_all_notifications", "User click on view notification", "view_all_notifications", "", { id: n.id, channel: n.channel });
                            setSelectedNotification(n);
                          }}
                        >
                          <div>{channelIcons[n.channel] || channelIcons.default}</div>
                          <div className={styles.notifContent}>
                            <div className={styles.notifTitle}>{n.title}</div>
                            <div className={styles.notifMessage}>{n.message}</div>
                            <div className={styles.notifTime}>{n.time}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <DashboardFooter />

        {/* Modal for detailed info */}
        {selectedNotification && (
          <div
            className={styles.modalOverlay}
            onClick={() => setSelectedNotification(null)}
          >
            <div
              className={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <FaTimes
                className={styles.modalClose}
                onClick={() => setSelectedNotification(null)}
              />
              <h4>Notification Details</h4>
              <p><strong>ID:</strong> {selectedNotification?.id}</p>
              <p><strong>Channel:</strong> {selectedNotification?.channel}</p>
              <p><strong>Type:</strong> {selectedNotification?.title}</p>
              <p><strong>Created:</strong> {selectedNotification?.time}</p>
              <div>
                <strong>Remark Details:</strong>
                {selectedNotification?.remark && Object.keys(selectedNotification.remark).length > 0 ? (
                  Object.keys(selectedNotification.remark).map((k) => (
                    <p key={k}><strong>{k}:</strong> {formatRemarkValue(selectedNotification.remark[k])}</p>
                  ))
                ) : (
                  <p>No remark details available</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewAllNotifications;
